import React, { Fragment } from 'react';
import parse from 'html-react-parser';

const InsightsCenterCard = ({ insightscenter }) => {
  const {
    imageUrl,
    imageAlt,
    assetIcon,
    assetType,
    title,
    url,
    linkLabel,
    minsRead,
    target
  } = insightscenter;

  let imageUrlWebp, assetIcons, imageSource;

  if (imageUrl) {
    if (imageUrl.indexOf('?') !== -1) {
      imageUrlWebp = `${imageUrl}&format=webp`;
    } else {
      imageUrlWebp = `${imageUrl}?format=webp`;
    }
  }
  if (assetType === 'VIDEO') {
    assetIcons = "<svg viewBox='0 0 18 18' name='video-icon' height='22.103px' width='24px'><use href='#video-icon' />";
  } else if (assetType === 'WEBINAR') {
    assetIcons = "<svg viewBox='0 0 18 18' name='video-icon' height='22.103px' width='24px'><use href='#video-icon' />";
  } else if (assetType === 'PODCAST') {
    assetIcons = "<svg viewBox='0 0 18 18' name='podcast-icon' height='22.103px' width='24px'><use href='#podcast-icon' />";
  } else {
    assetIcons = "<svg viewBox='0 0 18 18' name='article-icon' height='22.103px' width='24px'><use href='#article-icon' />";

  }

  const CommonInnerMarkup = (
    <Fragment>
      {imageUrl && (
        <picture className="insights-center-card-new__image">
          <source srcSet= {`${imageUrl}?w=777&h=437`} type="image/webp"></source>
          <img className="insights-center-card-new__image-source" src={`${imageUrl}?w=777&h=437`} alt={imageAlt} />
        </picture>
      )}
      <div className="insights-center-card-new__info">
        <span className="insights-center-image-card__type">
          <span className="insights-center-card__type-label">
            <span className='insights-center-card__type-label-icon'>{parse(assetIcons)}</span>
            <span className="insights-center-card__type-label-assetType">{assetType}</span></span>
        </span>
        <div className="insights-center-card-new__header">
          <div className="insights-center-card-new__name">{title}</div>
          <span className="insights-center-card-new__link">
            <svg viewBox="0 0 18 18" name="link-arrow-right-icon" className="right" >
              <use href="#link-arrow-right-icon" />
            </svg>
          </span>
        </div>
        <div className="insights-center-card-new__length"> {minsRead}</div>
      </div>
    </Fragment>
  );

  return (
    <a className="insights-center-card-new" href={url} target={target}>
      {CommonInnerMarkup}
    </a>
  );
};

export default InsightsCenterCard;
